import { supabase } from '../lib/supabase';
import { getEdgeFunctionErrorMessage } from '../lib/edgeFunctionErrors';

/**
 * Inscription publique dentiste (compte inactif jusqu'à validation admin).
 * @param {{ email: string, password: string, fullName: string, companyName?: string, phone?: string }} payload
 */
export async function registerDentistAccount(payload) {
  const { data, error } = await supabase.functions.invoke('register-dentist', {
    body: {
      email: payload.email?.trim(),
      password: payload.password,
      full_name: payload.fullName?.trim(),
      company_name: payload.companyName?.trim() || null,
      phone: payload.phone?.trim() || null,
    },
  });

  const serverMessage = await getEdgeFunctionErrorMessage(error, data);
  if (error || data?.error) {
    throw new Error(serverMessage || data?.error || 'Inscription impossible.');
  }

  return data;
}
